import {
  Attribute,
  JsonApiModel,
  JsonApiModelConfig,
} from '@elearnio/angular2-jsonapi';

@JsonApiModelConfig({
  type: 'tags',
})
export class TrainingTag extends JsonApiModel {
  @Attribute({ serializedName: 'name' })
  name!: string;

  @Attribute({ serializedName: 'color' })
  color!: string;

  @Attribute({ serializedName: 'author_id' })
  authorId!: number;

  @Attribute({ serializedName: 'trainings_count' })
  trainingsCount!: number;
}
